import React, { Component } from "react";
import { Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../css/Header.css";

export class Header extends Component {
  render() {
    return (
      <>
        <Navbar bg="dark" variant="dark" sticky="top">
          <Link to="/">
            <Navbar.Brand href="#home">
              <img
                alt=""
                src="/logo.svg"
                width="30"
                height="30"
                className="d-inline-block align-top"
              />{" "}
              Cubes
            </Navbar.Brand>
          </Link>
          <div className="ml-auto">
            <Link className="header__link" to="/login">
              Login
            </Link>
          </div>
        </Navbar>
      </>
    );
  }
}

export default Header;
